import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-healthcare-and-human-services',
  imports: [PillarPagesTemp],
  templateUrl: './healthcare-and-human-services.html',
  styleUrl: './healthcare-and-human-services.scss',
})
export class HealthcareAndHumanServices {

}
